import styles from './FunCard.module.less';

export default function FunCard({ caption, buttonTitle, image, onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.caption}>{caption}</div>
      <div
        className={styles['button-title']}
        onClick={(event) => {
          if (onClick) {
            onClick(event);
          }
        }}>
        {buttonTitle}
        <div className={styles['expand-right']}></div>
      </div>
      <img className={styles.img} src={image} />
    </div>
  );
}
